import { render } from "./subContent.vue?vue&type=template&id=e069b2d6"
import script from "./subContent.vue?vue&type=script&lang=js"
export * from "./subContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__